import { Tag, Typography } from 'antd';

interface IEnrollmentStatusCellProps {
  enrollmentRegistration?: string;
  enrollmentStatus?: string;
}

const STATUS_TAG = {
  active: { label: 'Ativo', color: 'success' },
  inactive: { label: 'Inativo', color: 'default' },
  cancelled: { label: 'Cancelado', color: 'error' }
} as const;

export const EnrollmentStatusCell = ({
  enrollmentRegistration,
  enrollmentStatus
}: IEnrollmentStatusCellProps) => {
  const status =
    STATUS_TAG[enrollmentStatus as keyof typeof STATUS_TAG] || STATUS_TAG.active;

  return (
    <div className="flex flex-col gap-1">
      <Typography.Text className="text-sm">
        {enrollmentRegistration || '-'}
      </Typography.Text>
      <Tag color={status.color} className="m-0 w-fit">
        {status.label}
      </Tag>
    </div>
  );
};
